// extracted by mini-css-extract-plugin
export default {"bannerContainer":"Banner_bannerContainer__Aul+b","texts":"Banner_texts__3+jsC"};